import { createContext, useContext, useState } from "react";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [search, setSearch] = useState({ jobTitle: "", location: "" });

  const [savedJobs, setSavedJobs] = useState([]);


  return (
    <SearchContext.Provider value={{ search, setSearch, savedJobs, setSavedJobs }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);
